import reducer from '../utils/reducer'
import {ACTION_NAMES} from '../utils/actionConstants'

const initialState = {
  loading: true
}

export default reducer(initialState, {
  [ACTION_NAMES.CONFIGURATION.UNLOAD_CONFIGURATION]: (state, payload) => {
    return initialState
  },
  [ACTION_NAMES.CONFIGURATION.REQUEST_CONFIGURATION]: (state, payload) => {
    return state
  },
  [ACTION_NAMES.CONFIGURATION.RECEIVE_CONFIGURATION]: (state, payload) => {
    return {
      ...payload,
      loading: false
    }
  }
})
